export function Illustration() {
  return (
    <svg
      width="117"
      height="121"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M89.085 59.432c-2.99-9.284-11.537-6.327-14.006-1.282-2.468 5.045 1.365 11.907 5.276 17.217 4.806 6.526 17.56 17.446 18.467 18.305.906.859 2.467 2.6 4.124 4.127 1.657 1.526 6.946 3.685 10.375.734 6.812-5.86 2.208-14.947 1.379-16.456-.829-1.509-2.146-5.58-9.294-9.602-4.787-2.694-12.583-1.438-16.32-13.043Z"
        fill="#A85D42"
      />
      <path
        d="M83.854 59.298c-.157-1.585 2.293-3.024 3.37-3.514 1.26 1.625 1.504 2.684 2.514 4.866.876 1.894 1.183 2.999 1.52 3.6-.798.447-2.423 1.447-3.625 1.505-1.501.073-3.582-4.476-3.779-6.457Z"
        fill="#CD9460"
      />
      <mask
        id="a"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="-1"
        y="1"
        width="100"
        height="100"
      >
        <path d="M-.108 1.082h98.92v98.921H-.108V1.082Z" fill="#C4C4C4" />
      </mask>
      <g mask="url(#a)">
        <path
          d="m60.966 66.724 4.297-4.364 7.274 7.162-4.297 4.365-7.274-7.163Z"
          fill="#ABA0AF"
        />
        <path
          d="M64.908 12.378c14.86 14.808 14.902 38.86.094 53.72-14.809 14.86-38.86 14.901-53.72.093-14.86-14.809-14.901-38.86-.093-53.72s38.86-14.901 53.72-.093Z"
          fill="#564260"
        />
        <path
          d="M59.112 18.193c11.647 11.606 11.68 30.457.073 42.104-11.606 11.647-30.457 11.68-42.104.073-11.647-11.606-11.68-30.457-.073-42.104 11.606-11.647 30.457-11.68 42.104-.073Z"
          fill="#FFDE91"
        />
      </g>
      <path
        d="M69.377 70.116a7.186 7.186 0 0 1 10.163-.079l33.351 31.74a7.186 7.186 0 1 1-10.084 10.242l-33.351-31.74a7.186 7.186 0 0 1-.079-10.163Z"
        fill="#564260"
      />
      <path
        d="M52.73 92a6.76 6.76 0 0 0 7.327 11.087 6.76 6.76 0 0 0 10.824 7.708l.976-.942a6.758 6.758 0 0 0 11.19 6.73l3.003-2.901a6.758 6.758 0 0 0 11.448 4.63l3.18-3.071a6.757 6.757 0 0 0-5.685-11.546 6.76 6.76 0 0 0-9.164-7.962 6.76 6.76 0 0 0-8.763-9.073A6.76 6.76 0 0 0 66.24 78.95L52.73 92.001Z"
        fill="#CD9460"
      />
      <path
        d="M66.413 48.413c-4.98 15.67-21.72 24.336-37.39 19.356C13.351 62.79 4.685 46.05 9.665 30.38c4.98-15.67 21.72-24.337 37.39-19.357 15.67 4.98 24.337 21.72 19.357 37.39Z"
        fill="#FF9587"
      />
      <path
        d="m40.133 46.107-7.81-2.482L38.82 23.18l7.811 2.482-6.498 20.446Zm-4.562.827c2.757.876 4.167 3.6 3.291 6.357-.876 2.757-3.6 4.168-6.357 3.292-2.757-.877-4.168-3.601-3.292-6.358.877-2.757 3.601-4.167 6.358-3.291Z"
        fill="#412A4C"
      />
    </svg>
  );
}
